module.exports = __webpack_public_path__ + "ico-weight.png?ac10dcd9156e63aebb7b32236d71ed6f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/ico-weight.png
// module id = 944
// module chunks = 0